import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { required, email } from '../validation';
import { Field, reduxForm } from 'redux-form';//, formValueSelector
import { Input } from '../components/Forms/Input';
import { config } from '../config';

let RequestPasswordResetForm = (props) => {
    const { handleSubmit } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Field name="email" type="email" component={Input} label="Email" validate={[required, email]} />
            <button className="btn btn-primary" type="submit">Send email</button>
        </form>
    )
}

RequestPasswordResetForm = reduxForm({ form: 'RequestPasswordResetForm' })(RequestPasswordResetForm);

export class RequestPasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestSent: false,
            email: ''
        }
        this.onRequestLink = this.onRequestLink.bind(this);
    }

    onRequestLink(e) {
        let url = config.apiUrl + `/ForgotPassword/SendResetEmail`;
        //console.log(e.email);
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(e.email)
        }).then(res => {
            //console.log(res);
            this.setState({ requestSent: true, email: e.email });
        });
    }

    render() {
        const request =
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h1>Forgot your password?</h1>
                    <p>Please enter the email registered with your account and we'll email you with a link to a secure web page where you can reset your password.</p>
                </div>
                <div className="panel-body">
                    <RequestPasswordResetForm onSubmit={this.onRequestLink} />
                </div>

                <div className="panel-footer">
                    <p>Be sure to check your spam or junk folder if you don't receive our email soon.</p>
                </div>
            </div>

        const response =
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h1>Forgotten password</h1>
                </div>
                <div className="panel-body">
                    <div className="alert alert-success">
                        <span>A secure link has been sent to your email address. Would you like to <Link className="alert-link" to="/Login">log in</Link>?</span>
                    </div>
                    <p>The link was sent to <span className="text-info">{this.state.email}</span>.</p>
                    <p>Click on the link in the email to enter a new password.</p>
                    <p>Once you have reset your password you can <Link to="/Login">log in</Link>.</p>
                    <p>Please note that the link will expire in <strong>24 hours</strong>.</p>
                    <p>Be sure to check your spam or junk folder if you don't receive our email soon.</p>

                </div>
            </div>

        return (
            <div className="h-center modal-dialog">
                {!this.state.requestSent ? request : response}
            </div>
        )
    }
}